export default "__VITE_ASSET__IU$0ClTi__"